import React from "react";
import { Box } from "@mui/material";
import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import AddIcon from "@mui/icons-material/Add";
import { listFooterAttribute, useDotLegalListStyles } from "./DotLegalList.styles";

export interface DotLegalListProps {
    children?: React.ReactNode;
    addButtonText?: string;
    onAddClick?: () => void;
    // Replaces the add button while adding needs more than a click, such as a search for the item to add.
    addContent?: React.ReactNode;
}

function DotLegalList(props: DotLegalListProps) {
    const styles = useDotLegalListStyles();
    const showAddButton = props.addButtonText && props.onAddClick;

    return (
        <Box sx={styles.list}>
            {props.children}
            {props.addContent ? (
                <Box {...{ [listFooterAttribute]: true }} sx={styles.addContent}>
                    {props.addContent}
                </Box>
            ) : (
                showAddButton && (
                    // Keeps focus where it is, so a row being edited does not lose its pending change to a blur mid-click.
                    <Box {...{ [listFooterAttribute]: true }} sx={styles.addButton} onMouseDown={(e) => e.preventDefault()}>
                        <DotLegalButton buttonType={"linkButton"} startIcon={<AddIcon />} onClick={props.onAddClick}>
                            {props.addButtonText}
                        </DotLegalButton>
                    </Box>
                )
            )}
        </Box>
    );
}

export default DotLegalList;
